module.exports = __webpack_public_path__ + "img/karmakurier_coco.f8cac0a1.png";